<template>
  <blockquote class="block-quote">
    <p v-html="block.content.text" />
    <cite v-if="block.content.attribution" v-html="block.content.attribution" />
  </blockquote>
</template>

<script setup>
defineProps(['block'])
</script>

<style scoped>
.block-quote {
  margin: 0;
  padding: 0 0 0 2rem;
  border-left: 1px solid var(--fg-20);
}

p {
  font-family: var(--serif);
  font-size: clamp(20px, 2.5vw, 36px);
  line-height: 1.25;
  font-style: italic;
  margin: 0 0 1rem;
}

cite {
  font-size: 1rem;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  opacity: 0.5;
  font-style: normal;
}
</style>
